

export const Filehelper ={

getFileName :(file: File | string | null) => {
  if (!file) return '';
  if (file instanceof File) return file.name;
  return file
}
}